import React from 'react'
import { twMerge } from 'tailwind-merge'

interface BackgroundPositionButtonProps {
  isActive: boolean
  isDisabled: boolean
  onClick: () => void
}

export const BackgroundPositionButton = ({
  isActive,
  onClick,
  isDisabled = false,
}: BackgroundPositionButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={twMerge(
        'h-2 w-2 transform cursor-pointer rounded-2xl bg-gray-300 transition-all duration-150 hover:bg-primary-500',
        isActive && 'scale-150 cursor-default bg-primary-500',
        isDisabled &&
          'scale-[0.625] cursor-default bg-gray-150 hover:bg-gray-150',
      )}
      type="button"
    />
  )
}
